<template>
    <b-modal id="create_project_modal" @ok="createProject">
        <template slot="modal-title">Create a new project</template>
        <form ref="create_project_form">
            <b-form-group
                    label="Project name"
                    label-for="project-name">
                <b-form-input
                        id="project-name"
                        :state="validateName"
                        v-model="new_project.name"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Project name is invalid, it needs at least {{minNameLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="User"
                    label-for="user">
                <b-form-select
                        id="user"
                        :state="validateUser"
                        v-model="new_project.user_id"
                        :options="user_options"
                        required/>
                <b-form-invalid-feedback :state="validateUser">
                    Select a User.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import ProjectRepository from '../../repositories/project.repository';

    export default {
        props: {
            new_project: {
                type: Object,
                default: ProjectRepository.blankProject
            },
            user_options: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {minNameLength: process.env.VUE_APP_VALIDATION_PROJECT_MIN_NAME_LENGTH}
        },
        methods: {
            checkFields() {
                if (ProjectRepository.validate.projectName(this.new_project.name) === false) return false;
                if (ProjectRepository.validate.user(this.new_project.user_id) === false) return false;
                return true;
            },
            createProject(modal) {
                // If the form is valid try creating a new user.
                if (this.$refs.create_project_form.checkValidity() && this.checkFields()) {
                    this.$emit('change-create-loading');
                    ProjectRepository.post(this.new_project).then(res => {
                        if (res.status === 201) { // Status 201 means created
                            // Emit the user-created event.
                            this.$emit('change-create-loading');
                            this.$emit('project-created', res.data);
                            // Restore the create user form.
                            this.new_project = ProjectRepository.blankProject();
                            // Notify the user.
                            this.$bvToast.toast(`Project ${res.data.name} successfully created.`, {
                                title: `Project created.`,
                                variant: 'success',
                                solid: true
                            });
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new project.', {
                                title: `Project creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('change-create-loading');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new project. Check the value\'s of all the fields', {
                                title: `Project creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new project.', {
                                title: `Project creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return ProjectRepository.validate.projectName(this.new_project.name);
            },
            validateUser() {
                return ProjectRepository.validate.user(this.new_project.user_id);
            }
        }
    }
</script>
